import * as RiskfactorListAction from './action';

const initialState = {
    riskFactorListSuccessData: null,
    riskFactorListFailure: null,
    uploadRiskFactorEditTemplate: [],
    uploadRiskFactorEditTemplateFailure: [],
    downloadRiskFactorEditTemplate: [],
    downloadRiskFactorEditTemplateFailure: []
}

const riskFactorListReducer = (state = initialState, action) => {
    switch (action.type) {
        case RiskfactorListAction.RISKFACTOR_LIST_SUCCESS:
            return state = {
                ...state,
                riskFactorListSuccessData: action.data
            }
        case RiskfactorListAction.RISKFACTOR_LIST_FAILURE:
            return state = {
                ...state,
                riskFactorListFailure: action.data
            }
        case RiskfactorListAction.DOWNLOAD_EDIT_RISK_FACTOR_TEMPLATE_SUCCESS:
            return state = {
                ...state,
                downloadRiskFactorEditTemplate: action.data
            }
        case RiskfactorListAction.DOWNLOAD_EDIT_RISK_FACTOR_TEMPLATE_FAILURE:
            return state = {
                ...state,
                downloadRiskFactorEditTemplateFailure: action.data
            }
        case RiskfactorListAction.UPLOAD_EDIT_RISK_FACTOR_TEMPLATE_SUCCESS:
            return state = {
                ...state,
                uploadRiskFactorEditTemplate: action.data
            }
        case RiskfactorListAction.UPLOAD_EDIT_RISK_FACTOR_TEMPLATE_FAILURE:
            return state = {
                ...state,
                uploadRiskFactorEditTemplateFailure: action.data
            }
        default:
            return state
    }
}

export default riskFactorListReducer;